import React, { useState, useEffect, useRef } from "react";
import {
    Row,
    Col,
    Typography,
    Button,
    message,
    Popconfirm,
    Card,
    DatePicker,
    ProTableOt,
    Form,
    useProTableOt,
    setParamsFilter,
    Tag,
    Select,
    Alert
} from "../../ui/ot";
// import { useQuestionAndAnswer } from "../controller/question_and_answer_controller";
import SerialOrderlistForm from "./serial_orderlist_form";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import dayjs from 'dayjs';

const SerialOrderlistEdit = ({
    keyPrefix = "cataloging.serial_orderlist_management",
    formView = "edit" //onlyRead view  

}) => {
    const navigate = useNavigate()
    const { t } = useTranslation('translation', { keyPrefix })
    const [searchParams, setSearchParams] = useSearchParams();
    const subscription_orderlist_id = searchParams.get('subscription_orderlist_id');
    const mode = searchParams.get('mode');
    const [form] = Form.useForm();
    const [reloadCount, setReloadCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success(t('add_success'));
                navigate(`../serial_orderlist_management?mode=edit&subscription_orderlist_id=${values?.subscription_orderlist_id}`)
            } else if (axiosMode === "patch") {
                message.success(t('modify_success'));
                dataReload(subscription_orderlist_id)
            } else if (axiosMode === "delete") {
                message.success(t('delete_success'));
                // actionRef.current.reloadAndRest();
                // setSelectedRowKeys([]);
                // setSelectedRowsInfo([]);
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error(t('add_failure'));
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "patch") {
                message.error(t('modify_failure'));
                // actionRef.current.reloadAndRest();
            } else if (axiosMode === "delete") {
                message.error(t('delete_failure'));
                // actionRef.current.reloadAndRest();
            }
        }
        if (axiosMode !== "get") {
            // setModalLoading(false);
            // setModalOpen(false);
        }
        setLoading(false)
    };
    const onBefore = ({ axiosMode, status, values }) => {
        // setModalLoading(true);
        setLoading(true)
    };
    const onFormFinish = (value) => {
        if (mode === "new") {
            SubscriptionOrderlistController.postData([
                value
            ])
        }
        else if (mode === "edit") {
            SubscriptionOrderlistController.patchData([
                value
            ])
        }
    }
    const dataReload = (subscription_orderlist_id) => {
        if (mode === "edit" || mode === "receive") {
            SubscriptionOrderlistController.getData({
                subscription_orderlist_id: subscription_orderlist_id
            }).then((response) => {
                let data = response?.data || []
                let firstData = data.find((ele) => true)
                let subscription_orderlist_task_data = (firstData?.subscription_orderlist_task_data || [])
                let subscription_orderlist_task_data_first = subscription_orderlist_task_data.find((ele) => true)
                subscription_orderlist_task_data_first = {
                    ...subscription_orderlist_task_data_first,
                    create_time: dayjs(subscription_orderlist_task_data_first?.create_time).format('YYYY-MM-DD HH:mm:ss'),
                    end_time: dayjs(subscription_orderlist_task_data_first?.end_time).format('YYYY-MM-DD'),
                    start_time: dayjs(subscription_orderlist_task_data_first?.start_time).format('YYYY-MM-DD'),
                }
                form.setFieldsValue({
                    ...firstData,
                    subscription_orderlist_task_data: [
                        subscription_orderlist_task_data_first
                    ]
                })
                setReloadCount((pre) => pre + 1)
            })
        }
        else if (mode === "new") {
            SubscriptionOrderlistController.getData({
                subscription_orderlist_id: subscription_orderlist_id
            }).then((response) => {
                let data = response?.data || []
                let firstData = data.find((ele) => true)
                // let subscription_orderlist_task_data = (firstData?.subscription_orderlist_task_data || [])
                // let subscription_orderlist_task_data_first = subscription_orderlist_task_data.find((ele) => true)
                let subscription_orderlist_items_data = firstData?.subscription_orderlist_items_data.map((value) => {
                    let newValue = value
                    delete newValue.subscriptionid
                    return {
                        ...newValue
                    }
                })
                form.setFieldsValue({
                    ...firstData,
                    subscription_orderlist_task_data: [
                        {
                            create_time: "",
                            end_time: "",
                            start_time: "",
                        }
                    ],
                    subscription_orderlist_items_data
                })
                setReloadCount((pre) => pre + 1)
            })
        }

    }
    const SubscriptionOrderlistController = useCRUDController({
        apiRoute: "/library/subscription_orderlist",
        onFinish,
        onBefore
    })

    useEffect(() => {
        if (subscription_orderlist_id) {
            dataReload(subscription_orderlist_id)
        }
        else {
            form.setFieldsValue({
                subscription_orderlist_task_data: [
                    {
                        "task_name": "",
                        "start_time": null,
                        "end_time": null,
                    }
                ]

            })
        }
    }, [subscription_orderlist_id])

    return (
        <Row gutter={[10, 10]} >
            <Col span={24}>
                <Row justify="space-between">
                    <Col>
                        <Typography.Title level={2}>{t('')}</Typography.Title>
                    </Col>
                    <Col>
                        <Row gutter={[8, 8]}>
                            <Col>
                                <Button
                                    loading={loading}
                                    type="default"
                                    onClick={() => {
                                        navigate(`../serial_orderlist_management`)
                                    }}
                                >
                                    {t('cancel')}
                                </Button>
                            </Col>
                            {formView === "edit" && <Col>
                                <Button
                                    loading={loading}
                                    onClick={() => {
                                        form.submit()
                                    }}
                                >
                                    {t('save')}
                                </Button>
                            </Col>}
                        </Row>
                    </Col>
                </Row>
            </Col>
            {mode === "new" && !!subscription_orderlist_id && <Col span={24}>
                <Alert
                    type={'warning'}
                    message={t('renew_journal_reminder')}
                    description={t('renew_journal_message')}
                />
            </Col>}
            <Col span={24}>
                <SerialOrderlistForm
                    propsForm={form}
                    onFormFinish={onFormFinish}
                    propsReloadCount={reloadCount}
                    formView={formView}
                />
            </Col>

        </Row>
    );
};
export default SerialOrderlistEdit;
